import React, { useEffect, useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ToastManager from '../../../default/popup/alert/apiNotification';

const AddNewCategoryPopup = ({ openModal, setOpen, type, onSubmitResponse }) => {
    const [title, setTitle] = useState('');
    const [error, setError] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false); 
    const closeModal = () => setOpen(false);
    const inputRef = useRef(null);
  
    useEffect(() => {
        if (openModal) {

        setTitle('');
        setError('')
          const timer = setTimeout(() => {
            inputRef.current?.focus();
          }, 100); 
    
          return () => clearTimeout(timer);
        }
      }, [openModal]);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const toastId = ToastManager.showLoading('Adding...');
        try {
            setIsProcessing(true);
            const response = await axios.post('/essential/group', {
                title: title,
                type: type
            });
            if (response.status >= 200 && response.status < 300) {
                ToastManager.showSuccess(toastId, response.data.message || 'Group added successfully!');
                onSubmitResponse(response)
            }
            setIsProcessing(false);
            setTitle('');
            closeModal();
        } catch (err) {
            setIsProcessing(false);
            let errorMsg = Object.values(err.response.data).join(', ')
            setError(errorMsg);
            ToastManager.showError(toastId, errorMsg || 'Failed to add Group.');
        }
    };
    

    return (
        <div>
            <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
                <div className="modal">
                    <div className="modal-header">
                        <h3>Add new {type === "cards" ? "category" : "Category"}</h3>
                        <Link className="close" onClick={closeModal}>
                          &times;
                        </Link>
                    </div>
                    <div className="modal-content">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>{type === "cards" ? "Category" : "Category"} name</label>
                                <input
                                    name="add_new_category"
                                    placeholder="e.g. Creative Solution"
                                    value={title}
                                    ref={inputRef}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            {error && <p className="error">{error}</p>}
                            <div className="text-right">
                                 <button type="submit" className="btn btn-submit" disabled={isProcessing}>
                                    {isProcessing ? 'Processing...' : 'Save'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

export default AddNewCategoryPopup;